import {
	peekSensorAsync,
	peekSensorConnection,
	SensorTbltParams,
} from '@Actions';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FLAGS } from '@Types';
import { Features } from 'luxon';
import { useDispatch } from 'react-redux';
import useFeatureFlagConfiguration from './useFeatureFlagConfigurations';

const useSensorPeekDataAsync = () => {
	const dispatch = useDispatch();

	const isNewSensorTestEnabled = !!useIsFeatureEnabled(
		FLAGS.NEW_SENSOR_SYSTEM_TESTS as unknown as keyof Features,
	);

	const { asyncTestsTimeoutMs } = useFeatureFlagConfiguration();

	function peekSensorDataAsync(
		peekForm: Record<string, string>,
		options: Partial<Record<'skipTblt', boolean>> = {},
	) {
		const { skipTblt = false } = options;
		const request: SensorTbltParams = {
			peekForm,
			timeoutMs: asyncTestsTimeoutMs,
			skipTblt,
		};
		if (isNewSensorTestEnabled) {
			dispatch(peekSensorAsync(request));
		} else {
			dispatch(peekSensorConnection(request));
		}
	}

	return { peekSensorDataAsync };
};

export default useSensorPeekDataAsync;
